import React from "react";

interface CheckboxProps {
  checked: boolean;
  onChange: (checked: boolean) => void;
  label: React.ReactNode;
  className?: string;
}

export default function Checkbox({
  checked,
  onChange,
  label,
  className,
}: CheckboxProps) {
  return (
    <label
      className={`flex items-center gap-2 p-[20px_16px] border-[1.125px] border-[#18181C] bg-[#18181C] align-self-stretch  ${
        className || ""
      }`}
      style={{ borderRadius: 12 }}
    >
      <span>
        <input
          type="checkbox"
          checked={checked}
          onChange={(e) => onChange(e.target.checked)}
          className="peer appearance-none w-[15px] h-[15px] rounded-[3px] border border-[#CBCED1] bg-[#18181C] checked:bg-[#18181C] checked:border-[#CBCED1] flex items-center justify-center transition-colors duration-150 focus:outline-none relative cursor-pointer"
        />
      </span>

      {/* Custom checkmark */}
      <span className="pointer-events-none absolute w-[15px] h-[15px] flex items-center justify-center cursor-pointer">
        {checked && (
          <svg
            width="15"
            height="15"
            viewBox="0 0 27 27"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <rect
              x="1.5"
              y="1.5"
              width="24"
              height="24"
              rx="6"
              fill="#18181C"
              stroke="#CBCED1"
              strokeWidth="3"
            />
            <path
              d="M7 14L12 19L20 9"
              stroke="#CBCED1"
              strokeWidth="3"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        )}
      </span>
      <span className="text-[#CBCED1] font-['Neue Montreal'] text-[15.75px] font-medium leading-[22.5px] ml-2 select-none">
        {label}
      </span>
    </label>
  );
}
